export const setDefaultSvgDimensions = (svg: SVGElement, width = '18', height = '18') => {
    svg.setAttribute('width', width);
    svg.setAttribute('height', height);
};
